import { Suspense, lazy } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { useShallow } from "zustand/react/shallow";
import warehouses from "./data/warehouses.json";
import "./index.css";
import { useStore } from "./store/store";
import { ProtectedRoute } from "./view/tablo-compact/components/ProtectedRoute/ProtectedRoute";

const EnterPage = lazy(
  () => import("./view/tablo-compact/enter-page/enter-page"),
);
const OfficeSelectPage = lazy(
  () => import("./view/tablo-compact/office-select-page/office-select-page"),
);
const QueuePositionPage = lazy(
  () => import("./view/tablo-compact/queue-position-page/queue-position-page"),
);
const QrCodePage = lazy(
  () => import("./view/tablo-compact/qr-code-page/qr-code-page"),
);
const GeoPermissionPage = lazy(
  () => import("./view/tablo-compact/geo-permission-page/geo-permission-page"),
);
const GeoRequestPage = lazy(
  () => import("./view/tablo-compact/geo-request-page/geo-request-page"),
);
const GeoFailPage = lazy(
  () => import("./view/tablo-compact/geo-fail-page/geo-fail-page"),
);
const QrExpiredPage = lazy(
  () => import("./view/tablo-compact/qr-expired-page/qr-expired-page"),
);
const WarehouseListPage = lazy(
  () => import("./view/warehouse-list-page/warehouse-list-page"),
);
const WarehouseSchemaPage = lazy(
  () => import("./view/warehouse-schema-page/warehouse-schema-page"),
);
const CarPage = lazy(() => import("./view/car-page/car-page"));

export const App = () => {
  const { height, translate } = useStore(
    useShallow(state => ({
      height: state.height,
      translate: state.translate,
    })),
  );

  return (
    <Suspense fallback="">
      <div style={{ height: height, transform: translate }} className={"app"}>
        <BrowserRouter basename={"/"}>
          <Routes>
            <Route path="/" element={<EnterPage />} />
            <Route path="/office-select" element={<OfficeSelectPage />} />
            <Route path="/queue-position" element={<QueuePositionPage />} />
            <Route path="/qr-code/:officeId" element={<QrCodePage />} />
            <Route
              path="/geo/permission"
              element={
                <ProtectedRoute>
                  <GeoPermissionPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/geo/request"
              element={
                <ProtectedRoute>
                  <GeoRequestPage />
                </ProtectedRoute>
              }
            />
            <Route path="/geo/fail/:gate" element={<GeoFailPage />} />
            <Route path="/qr-expired" element={<QrExpiredPage />} />
            <Route path="/by-token/:token" element={<EnterPage />} />
            {warehouses.map(elem => (
              <Route
                path={`/${elem.query}`}
                key={elem.id}
                element={<WarehouseListPage />}
              />
            ))}
            {warehouses.map(elem => (
              <Route
                path={`/warehouse/:warehousesId/car/:number`}
                key={elem.id}
                element={<CarPage />}
              />
            ))}
            <Route path="/:id/schema" element={<WarehouseSchemaPage />} />
          </Routes>
        </BrowserRouter>
      </div>
    </Suspense>
  );
};
